import request from "@/utils/request.util";

export const getListPackage = async (payload) => {
  const params = {
    params: payload,
  };
  return request.get("/restaurant_packages", params);
};

export const getAddOnListPackage = async (payload) => {
  const params = {
    params: payload,
  };
  return request.get("/restaurant_add_ons.json", params);
};

export const createNewPackage = async (restaurantId, packageType, payload) => {
  return request.post(
    `/restaurant_packages.json?restaurant_id=${restaurantId}&package_type=${packageType}`,
    payload,
  );
};

export const changeStatusPackage = async (payload) => {
  return request.post("/restaurant_packages/change_active", payload);
};

export const exportListPackage = async (payload) => {
  return request.post("/restaurant_packages/export", payload);
};

export const duplicatePackage = async (payload) => {
  return request.post(`/restaurant_packages/duplicate`, payload);
};

export const deletePackage = async (id) => {
  return request.delete(`/restaurant_packages/${id}`);
};

export const deleteAllPackageItem = async () => {
  return request.delete("restaurant_packages/destroy_all");
};

export const getPaymentType = async (restaurantId) => {
  const params = {
    params: { restaurant_id: restaurantId },
  };
  return request.get("/restaurant_packages/payment_types", params);
};

export const getPackageDetails = async (id) => {
  return request.get(`/restaurant_packages/${id}`);
};

export const updatePackage = async (id, payload) => {
  return request.put("/restaurant_packages/" + id, payload);
};

export const getMenuV2PreviewLink = async (link) => {
  const axios = await import("axios");
  return axios.get(link);
};

export const getPackageSubmission = async (submissionId, payload) => {
  const params = {
    params: { restaurant_id: payload.restaurantId },
  };
  if (payload.token) {
    params.headers = { Authorization: `Bearer ${payload.token}` };
  }
  return request.get(`/package_submissions/${submissionId}`, params);
};

export const getPackageSubmissionDetail = async (restaurantPackageId, payload) => {
  const params = {
    params: { restaurant_id: payload.restaurantId },
  };
  if (payload.token) {
    params.headers = { Authorization: `Bearer ${payload.token}` };
  }
  return request.get(`/restaurant_packages/${restaurantPackageId}`, params);
};

export const getPackageSubmissionPaymentType = async (payload) => {
  const params = {
    params: { restaurant_id: payload.restaurantId },
  };
  if (payload.token) {
    params.headers = { Authorization: `Bearer ${payload.token}` };
  }
  return request.get("/restaurant_packages/payment_types", params);
};

export const approvePackageSubmission = async (submissionId, payload, token) => {
  const params = {
    headers: { Authorization: `Bearer ${token}` },
  };
  return request.patch(`/package_submissions/${submissionId}/approve`, payload, params);
};

export const rejectPackageSubmission = async (submissionId, payload, token) => {
  const params = {
    headers: { Authorization: `Bearer ${token}` },
  };
  return request.patch(`/package_submissions/${submissionId}/reject`, payload, params);
};

export const setCoverImage = async (id, file) => {
  const formData = new FormData();
  formData.append("cover_image", file);
  return request.patch(`/restaurant_packages/${id}/cover_image`, formData);
};

export const removeCoverImage = async (id) => {
  return request.delete(`/restaurant_packages/${id}/cover_image`);
};
